import { render, staticRenderFns } from "./free-gift-drawer.vue?vue&type=template&id=49f12f96&scoped=true&"
import script from "./free-gift-drawer.vue?vue&type=script&lang=js&"
export * from "./free-gift-drawer.vue?vue&type=script&lang=js&"
import style0 from "./free-gift-drawer.vue?vue&type=style&index=0&id=49f12f96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f12f96",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrawerHeader: require('/app/components/drawer/components/drawerHeader.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
